<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
    <!--<router-view/>-->
  </div>
</template>
<script>
export default {
  components: {

  }
}
</script>
<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #fff;
  min-height: 100%;
  max-width: 100%;
  overflow-x: hidden;
}
html,
body {
  height: 100%;
}
* {
  box-sizing: border-box;
}
</style>
